import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";
import { Divider2 } from "@/ui2/atoms/Divider";

export function AssessmentSkeleton() {
  return (
    <DashboardCard2
      className="tw:mx-auto tw:w-full tw:md:mt-10 tw:md:max-w-188"
      headingProps={{ size: 3 }}
      title={
        <div className="tw:flex tw:flex-col tw:gap-2">
          <Skeleton height={28} width={300} />
          <Skeleton height={18} width={100} />
        </div>
      }
    >
      <div className="tw:flex tw:flex-col tw:gap-6">
        {/* Question 1 skeleton */}
        <div>
          {/* Question index and text */}
          <Skeleton className="tw:mb-2" height={15} width={50} />
          <Skeleton className="tw:mb-4" height={20} width="65%" />

          {/* Radio options */}
          <div className="tw:space-y-3">
            {["35%", "95%", "70%"].map((width, index) => (
              <OptionSkeleton key={`question-1-option-${index}`} textWidth={width} />
            ))}
          </div>
        </div>

        {/* Question 2 skeleton */}
        <div>
          {/* Question index and text */}
          <Skeleton className="tw:mb-2" height={15} width={50} />
          <Skeleton className="tw:mb-1" height={20} width="80%" />
          <Skeleton className="tw:mb-4" height={20} width="35%" />

          {/* Checkbox options */}
          <div className="tw:space-y-3">
            {["45%", "55%", "25%", "70%", "40%"].map((width, index) => (
              <OptionSkeleton key={`question-2-option-${index}`} textWidth={width} />
            ))}
          </div>
        </div>

        {/* Question 3 skeleton - Rating type */}
        <div>
          {/* Question index and text */}
          <Skeleton className="tw:mb-2" height={15} width={50} />
          <Skeleton className="tw:mb-4" height={20} width="90%" />

          {/* Rating options - horizontal layout */}
          <div className="tw:flex tw:gap-3">
            {Array.from({ length: 5 }).map((_, index) => (
              <RatingOptionSkeleton key={`question-3-option-${index}`} />
            ))}
          </div>
        </div>

        {/* CTAs */}
        <Divider2 />
        <div className="tw:flex tw:justify-end tw:gap-3">
          <Skeleton className="tw:mb-2" height={44} width={86} />
          <Skeleton className="tw:mb-1" height={44} width={160} />
        </div>
      </div>
    </DashboardCard2>
  );
}

function OptionSkeleton({ textWidth }: { textWidth: string }) {
  return (
    <div className="tw:flex tw:items-center tw:gap-3 tw:rounded-lg tw:border tw:border-stroke-quaternary tw:p-2">
      <Skeleton
        className="tw:flex tw:shrink-0 tw:rounded-md"
        containerClassName="tw:flex"
        height={32}
        width={32}
      />
      <div className="tw:flex-1">
        <Skeleton height={16} width={textWidth} />
      </div>
    </div>
  );
}

function RatingOptionSkeleton() {
  return (
    <div className="tw:flex-1">
      <Skeleton className="tw:rounded-lg" height={64} />
    </div>
  );
}
